import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbAlert as AbAlertImpl, AlertLevel as AbAlertLevelImpl } from "abreact/popup/AbAlert";
import { AbAlertLevel } from "absdk/commons/ui/feedback/AbAlertLevel";
import * as React from "react";

/**
 * An enumeration representing possible levels of alerts to be shown to the user.
 * @deprecated Use absdk/commons/ui/feedback/AbAlertLevel
 */
export { AbAlertLevel as AlertLevel };

/**
 * Properties of the AbAlert component.
 */

/**
 * The **AbAlert** component displays an alert message, either inline or as a popup (via methods).
 *
 * [[include:absdk/commons/ui/popup/AbAlert.md]]
 */
export class AbAlert extends React.Component {
  /**
   * Shows an alert modal dialog.
   *
   * @param {AbAlertProps} props The properties of the alert.
   * @returns {AbPopupHandle} The handle of the dialog popup that was shown.
   */
  static show(props) {
    return AbAlertImpl.show(this.mapProps(props));
  }
  static showInfo(message, title) {
    return AbAlert.show({
      level: AbAlertLevel.INFO,
      title: title,
      message: message
    });
  }
  static showSuccess(message, title) {
    return AbAlert.show({
      level: AbAlertLevel.SUCCESS,
      title: title,
      message: message
    });
  }
  static showWarning(message, title) {
    return AbAlert.show({
      level: AbAlertLevel.WARNING,
      title: title,
      message: message
    });
  }
  static showError(message, title) {
    return AbAlert.show({
      level: AbAlertLevel.ERROR,
      title: title,
      message: message
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(AbAlertImpl, AbAlert.mapProps(this.props));
  }
}
_defineProperty(AbAlert, "mapProps", props => {
  const {
    level,
    ...rest
  } = props;
  switch (level) {
    case AbAlertLevel.INFO:
      return {
        level: AbAlertLevelImpl.INFO,
        ...rest
      };
    case AbAlertLevel.SUCCESS:
      return {
        level: AbAlertLevelImpl.SUCCESS,
        ...rest
      };
    case AbAlertLevel.WARNING:
      return {
        level: AbAlertLevelImpl.WARNING,
        ...rest
      };
    case AbAlertLevel.ERROR:
      return {
        level: AbAlertLevelImpl.ERROR,
        ...rest
      };
  }
});
//# sourceMappingURL=AbAlert.js.map
